import Vue from 'vue'
import Router from 'vue-router'

import dashboard from '@/components/dashboard'
import actuals from '@/components/actuals'
import actuals_tbn from '@/components/actuals_tbn'
import actuals_fasttrak from '@/components/actuals_fasttrak'
import booking_feed from '@/components/booking_feed'
import booking_dashboard from '@/components/booking_dashboard'
import arrivals_departures_board from '@/components/arrivals_departures_board'
import arrivals_departures_board_large from '@/components/arrivals_departures_board_large'
import bus_tracker from '@/components/bus_tracker'
import actuals_mileage_tbn from '@/components/actuals_mileage_tbn'
import actuals_mileage_cm from '@/components/actuals_mileage_cm'
//import tenant_config from '@/components/tenant_config'
import tenant_config_history from '@/components/tenant_config_history'
import tenant_config_general from '@/components/tenant_config_general'
import tenant_config_bookings_actuals from '@/components/tenant_config_bookings_actuals'
import tenant_config_cust_map_views from '@/components/tenant_config_cust_map_views'
import tenant_config_views_reports from '@/components/tenant_config_views_reports'
import tenant_config_alerts from '@/components/tenant_config_alerts'
import tenant_config_notifications from '@/components/tenant_config_notifications'
import tenant_config_bus_sos from '@/components/tenant_config_bus_sos'
import tenant_config_veh_status_mgmt from '@/components/tenant_config_veh_status_mgmt'
import tenant_config_data_services from '@/components/tenant_config_data_services'
import tenant_config_fleet_assistant from '@/components/tenant_config_fleet_assistant'

import tenant_manager from '@/components/tenant_manager'
import admin_dashboard from '@/components/admin_dashboard'
import planned_vehicle_daily from '@/components/planned_vehicle_daily'
import planned_vehicle_daily_tbn from '@/components/planned_vehicle_daily_tbn'
import planned_drivers_daily_tbn from '@/components/planned_drivers_daily_tbn'
import planned_drivers_daily from '@/components/planned_drivers_daily'
import login from "@/components/login"
import planned_vehicle_weekly from "@/components/planned_vehicle_weekly";
import planned_vehicle_weekly_tbn from "@/components/planned_vehicle_weekly_tbn";
import planned_drivers_weekly_dispatch_tbn from "@/components/planned_drivers_weekly_dispatch_tbn";
import planned_drivers_weekly_util_tbn from "@/components/planned_drivers_weekly_util_tbn";
import booking_monthly_view_tbn from "@/components/booking_monthly_view_tbn";
import planned_vehicle_types_monthly from "@/components/planned_vehicle_types_monthly";
import planned_vehicle_types_monthly_tbn from "@/components/planned_vehicle_types_monthly_tbn";
import planned_driver_types_monthly_tbn from "@/components/planned_driver_types_monthly_tbn";
import planned_driver_types_monthly_cm from "@/components/planned_driver_types_monthly_cm";
import vehicle_map from "@/components/vehicle_map";
import vehicle_map_future from "@/components/vehicle_map_future";
import vehicle_map_direct from "@/components/vehicle_map_direct";
import vehicle_map_driver from "@/components/vehicle_map_driver";
import vehicle_map_track from "@/components/vehicle_map_track";
import vehicle_trip_history from "@/components/vehicle_trip_history";
import vehicle_route_history from "@/components/vehicle_route_history";
import vehicle_map_track_fleet from "@/components/vehicle_map_track_fleet";
import vehicle_map_track_fleet_fabbus from "@/components/vehicle_map_track_fleet_fabbus";
import vehicle_map_by_booking from "@/components/vehicle_map_by_booking";
import direct_register from "@/components/direct_register";
import report_unplanned_vehicle from "@/components/report_unplanned_vehicle";
import report_unplanned_hos from "@/components/report_unplanned_hos";
import report_otp from "@/components/report_otp";
import otp_history from "@/components/otp_history";
import actuals_billing_report from "@/components/actuals_billing_report";
import actuals_vehicle_report from "@/components/actuals_vehicle_report";
import smart_route_assignments from "@/components/smart_route_assignments";
import smart_route_assignments_tbn from "@/components/smart_route_assignments_tbn";
import actuals_billing_report_tbn from "@/components/actuals_billing_report_tbn";
import intrastate_booking_report_tbn from "@/components/intrastate_booking_report_tbn";
import trip_linker_report_tbn from "@/components/trip_linker_report_tbn";
import actuals_start_events_report_tbn from "@/components/actuals_start_events_report_tbn";
import actuals_driver_payroll_report from "@/components/actuals_driver_payroll_report";
import actuals_driver_payroll_report_tbn from "@/components/actuals_driver_payroll_report_tbn";
import actuals_drivers_daily_report from "@/components/actuals_drivers_daily_report";
import actuals_driver_multiday_report from "@/components/actuals_driver_multiday_report";
import actuals_hours_by_client_report from "@/components/actuals_hours_by_client_report";
import actuals_hours_by_client_report_tbn from "@/components/actuals_hours_by_client_report_tbn";
import actuals_hours_by_booking_report_tbn from "@/components/actuals_hours_by_booking_report_tbn";
import actuals_mileage_by_booking_report from "@/components/actuals_mileage_by_booking_report";
import actuals_driver_multiday_report_tbn from "@/components/actuals_driver_multiday_report_tbn";
import actuals_payroll_summary_report_tbn from "@/components/actuals_payroll_summary_report_tbn";
import actuals_payroll_summary_report from "@/components/actuals_payroll_summary_report";
import actuals_perf_report from "@/components/actuals_perf_report";
import actuals_multiday_otp_report from "@/components/actuals_multiday_otp_report";
import actuals_perf_report_tbn from "@/components/actuals_perf_report_tbn";
import actuals_multiday_otp_report_tbn from "@/components/actuals_multiday_otp_report_tbn";
import group_message_sender from "@/components/group_message_sender.vue";
import group_message_sender_tbn from "@/components/group_message_sender_tbn.vue";
import support_ticket_list from "@/components/support_ticket_list.vue";
import support_ticket_create from "@/components/support_ticket_create.vue";
import support_ticket_details from "@/components/support_ticket_details.vue";
import fleet_assistant from "@/components/fleet_assistant.vue";
import user_list from "@/components/user_list.vue";
import driver_list from "@/components/driver_list.vue";
import driver_list_tbn from "@/components/driver_list_tbn.vue";
import route_addresses from "@/components/route_addresses.vue";
import route_assignments from "@/components/route_assignments.vue";
import report_converter from "@/components/report_converter.vue";
import user_detail from "@/components/user_detail.vue";
import driver_detail from "@/components/driver_detail.vue";
import driver_detail_tbn from "@/components/driver_detail_tbn.vue";
import user_create from "@/components/user_create.vue";
import alert_list from "@/components/alert_list";
import hos_history_report from "@/components/hos_history_report";
import tyler_route_processor from "@/components/tyler_route_processor";
import compare_drivers from "@/components/compare_drivers";
import compare_driver_profiles from "@/components/compare_driver_profiles";
import compare_drivers_history from "@/components/compare_drivers_history";
import driver_scorecard from "@/components/driver_scorecard";
import driver_comparison from "@/components/driver_comparison";
import booking_file_list from "@/components/booking_file_list";
import actuals_simulator from "@/components/actuals_simulator";
import event_notes_list from "@/components/event_notes_list";
import vehicle_status from "@/components/vehicle_status";
import vehicle_status_es from "@/components/vehicle_status_es";
import vehicle_status_history from "@/components/vehicle_status_history";
import vehicle_status_dvir from "@/components/vehicle_status_dvir";
import vehicle_status_dvir_fasttrak from "@/components/vehicle_status_dvir_fasttrak";
import vehicle_status_dvir_tbn from "@/components/vehicle_status_dvir_tbn";
import vehicle_status_maint_tbn from "@/components/vehicle_status_maint_tbn";
import vehicle_status_maint from "@/components/vehicle_status_maint";
import vehicle_status_tbn from "@/components/vehicle_status_tbn";
import trip_sheet_tbn from "@/components/trip_sheet_tbn";
import driver_board from "@/components/driver_board";
import vehicle_maint_summary from "@/components/vehicle_maint_summary";
import trip_sheet from "@/components/trip_sheet";
import dispatch_board_tbn from "@/components/dispatch_board_tbn";
import dispatch_bookings_driver_bid_board_tbn from "@/components/dispatch_bookings_driver_bid_board_tbn";
import sos_list from "@/components/sos_list";
import sos_detail from "@/components/sos_detail.vue";
import process_manager_list from "@/components/process_manager_list";
import dispatch_bookings_driver_bid_manager_board_tbn from '../components/dispatch_bookings_driver_bid_manager_board_tbn'

Vue.use(Router)

let router = new Router({

    routes: [
        {
            path: '/',
            redirect: { name: 'login' }
        }, {
            path: '/login',
            name: 'login',
            component: login
        }, {
            path: '/login/:nextUrl',
            name: 'login_redirect',
            component: login
        }, {
            path: '/dashboard',
            name: 'dashboard',
            component: dashboard,
        }, {
            path: '/admin_dashboard',
            name: 'admin_dashboard',
            component: admin_dashboard,
        }, {
            path: '/actuals',
            name: 'actuals',
            component: actuals,
        }, {
            path: '/booking_dashboard',
            name: 'booking_dashboard',
            component: booking_dashboard,
        }, {
            path: '/arrivals_departures_board',
            name: 'arrivals_departures_board',
            component: arrivals_departures_board,
        }, {
            path: '/arrivals_departures_board_large',
            name: 'arrivals_departures_board_large',
            component: arrivals_departures_board_large,
        }, {
            path: '/bus_tracker',
            name: 'bus_tracker',
            component: bus_tracker,
        }, {
            path: '/booking_feed',
            name: 'booking_feed',
            component: booking_feed,
        }, {
            path: '/actuals_tbn',
            name: 'actuals_tbn',
            component: actuals_tbn,
        }, {
            path: '/actuals_fasttrak',
            name: 'actuals_fasttrak',
            component: actuals_fasttrak,
        }, 
        // {
        //     path: '/tenant_config',
        //     name: 'tenant_config',
        //     component: tenant_config,
        // }, 
        {
            path: '/tenant_config_history',
            name: 'tenant_config_history',
            component: tenant_config_history,
        }, {
            path: '/tenant_config_general',
            name: 'tenant_config_general',
            component: tenant_config_general,
        }, {
            path: '/tenant_config_bookings_actuals',
            name: 'tenant_config_bookings_actuals',
            component: tenant_config_bookings_actuals,
        }, {
            path: '/tenant_config_cust_map_views',
            name: 'tenant_config_cust_map_views',
            component: tenant_config_cust_map_views,
        }, {
            path: '/tenant_config_views_reports',
            name: 'tenant_config_views_reports',
            component: tenant_config_views_reports,
        }, {
            path: '/tenant_config_alerts',
            name: 'tenant_config_alerts',
            component: tenant_config_alerts,
        }, {
            path: '/tenant_config_notifications',
            name: 'tenant_config_notifications',
            component: tenant_config_notifications,
        }, {
            path: '/tenant_config_bus_sos',
            name: 'tenant_config_bus_sos',
            component: tenant_config_bus_sos,
        }, {
            path: '/tenant_config_veh_status_mgmt',
            name: 'tenant_config_veh_status_mgmt',
            component: tenant_config_veh_status_mgmt,
        }, {
            path: '/tenant_config_data_services',
            name: 'tenant_config_data_services',
            component: tenant_config_data_services,
        }, {
            path: '/tenant_config_fleet_assistant',
            name: 'tenant_config_fleet_assistant',
            component: tenant_config_fleet_assistant,

        }, {
            path: '/tenant_manager',
            name: 'tenant_manager',
            component: tenant_manager,
        }, {
            path: '/planned_vehicle_daily',
            name: 'planned_vehicle_daily',
            component: planned_vehicle_daily,
        }, {
            path: '/planned_vehicle_daily_tbn',
            name: 'planned_vehicle_daily_tbn',
            component: planned_vehicle_daily_tbn,
        }, {
            path: '/actuals_mileage_cm',
            name: 'actuals_mileage_cm',
            component: actuals_mileage_cm,
        }, {
            path: '/actuals_mileage_tbn',
            name: 'actuals_mileage_tbn',
            component: actuals_mileage_tbn,
        }, {
            path: '/planned_drivers_daily',
            name: 'planned_drivers_daily',
            component: planned_drivers_daily,
        }, {
            path: '/planned_drivers_daily_tbn',
            name: 'planned_drivers_daily_tbn',
            component: planned_drivers_daily_tbn,
        }, {
            path: '/planned_vehicle_weekly',
            name: 'planned_vehicle_weekly',
            component: planned_vehicle_weekly,
        }, {
            path: '/planned_vehicle_weekly_tbn',
            name: 'planned_vehicle_weekly_tbn',
            component: planned_vehicle_weekly_tbn,
        },         {
            path: '/planned_drivers_weekly_dispatch_tbn',
            name: 'planned_drivers_weekly_dispatch_tbn',
            component: planned_drivers_weekly_dispatch_tbn,
        }, {
            path: '/booking_monthly_view_tbn',
            name: 'booking_monthly_view_tbn',
            component: booking_monthly_view_tbn,
        }, {
            path: '/planned_drivers_weekly_util_tbn',
            name: 'planned_drivers_weekly_util_tbn',
            component: planned_drivers_weekly_util_tbn,
        }, {
            path: '/planned_vehicle_types_monthly',
            name: 'planned_vehicle_types_monthly',
            component: planned_vehicle_types_monthly,
        }, {
            path: '/planned_vehicle_types_monthly_tbn',
            name: 'planned_vehicle_types_monthly_tbn',
            component: planned_vehicle_types_monthly_tbn,
        }, {
            path: '/planned_driver_types_monthly_tbn',
            name: 'planned_driver_types_monthly_tbn',
            component: planned_driver_types_monthly_tbn,
        }, {
            path: '/planned_driver_types_monthly_cm',
            name: 'planned_driver_types_monthly_cm',
            component: planned_driver_types_monthly_cm,
        }, {
            path: '/vehicle_map',
            name: 'vehicle_map',
            component: vehicle_map,
        }, {
            path: '/vehicle_map_future',
            name: 'vehicle_map_future',
            component: vehicle_map_future,
        }, {
            path: '/report_unplanned_vehicle',
            name: 'report_unplanned_vehicle',
            component: report_unplanned_vehicle,
        }, {
            path: '/report_unplanned_hos',
            name: 'report_unplanned_hos',
            component: report_unplanned_hos,
        }, {
            path: '/report_otp',
            name: 'report_otp',
            component: report_otp,
        },{
            path: '/otp_history',
            name: 'otp_history',
            component: otp_history,
        },{
            path: '/actuals_perf_report',
            name: 'actuals_perf_report',
            component: actuals_perf_report,
        },{
            path: '/actuals_multiday_otp_report',
            name: 'actuals_multiday_otp_report',
            component: actuals_multiday_otp_report,
        },{
            path: '/actuals_billing_report',
            name: 'actuals_billing_report',
            component: actuals_billing_report,
        },{
            path: '/actuals_vehicle_report',
            name: 'actuals_vehicle_report',
            component: actuals_vehicle_report,
        },{
            path: '/smart_route_assignments',
            name: 'smart_route_assignments',
            component: smart_route_assignments,
        },{
            path: '/smart_route_assignments_tbn',
            name: 'smart_route_assignments_tbn',
            component: smart_route_assignments_tbn,
        },{
            path: '/actuals_billing_report_tbn',
            name: 'actuals_billing_report_tbn',
            component: actuals_billing_report_tbn,
        },{
            path: '/intrastate_booking_report_tbn',
            name: 'intrastate_booking_report_tbn',
            component: intrastate_booking_report_tbn,
        },{
            path: '/trip_linker_report_tbn',
            name: 'trip_linker_report_tbn',
            component: trip_linker_report_tbn,
        },{
            path: '/actuals_start_events_report_tbn',
            name: 'actuals_start_events_report_tbn',
            component: actuals_start_events_report_tbn,
        },{
            path: '/actuals_driver_payroll_report',
            name: 'actuals_driver_payroll_report',
            component: actuals_driver_payroll_report,
        },{
            path: '/actuals_driver_payroll_report_tbn',
            name: 'actuals_driver_payroll_report_tbn',
            component: actuals_driver_payroll_report_tbn,
        },{
            path: '/actuals_drivers_daily_report',
            name: 'actuals_drivers_daily_report',
            component: actuals_drivers_daily_report,
        },{
            path: '/actuals_driver_multiday_report',
            name: 'actuals_driver_multiday_report',
            component: actuals_driver_multiday_report,
        },{
            path: '/actuals_hours_by_client_report',
            name: 'actuals_hours_by_client_report',
            component: actuals_hours_by_client_report,
        },{
            path: '/actuals_hours_by_client_report_tbn',
            name: 'actuals_hours_by_client_report_tbn',
            component: actuals_hours_by_client_report_tbn,
        },{
            path: '/actuals_hours_by_booking_report_tbn',
            name: 'actuals_hours_by_booking_report_tbn',
            component: actuals_hours_by_booking_report_tbn,
        },{
            path: '/actuals_mileage_by_booking_report',
            name: 'actuals_mileage_by_booking_report',
            component: actuals_mileage_by_booking_report,
        },{
            path: '/actuals_driver_multiday_report_tbn',
            name: 'actuals_driver_multiday_report_tbn',
            component: actuals_driver_multiday_report_tbn,
        },{
            path: '/actuals_payroll_summary_report_tbn',
            name: 'actuals_payroll_summary_report_tbn',
            component: actuals_payroll_summary_report_tbn,
        },{
            path: '/actuals_payroll_summary_report',
            name: 'actuals_payroll_summary_report',
            component: actuals_payroll_summary_report,
        },{
            path: '/actuals_perf_report_tbn',
            name: 'actuals_perf_report_tbn',
            component: actuals_perf_report_tbn,
        },{
            path: '/actuals_multiday_otp_report_tbn',
            name: 'actuals_multiday_otp_report_tbn',
            component: actuals_multiday_otp_report_tbn,
        }, {
            path: '/processmgr',
            name: 'process_manager_list',
            component: process_manager_list,
        }, {
            path: '/group_message_sender',
            name: 'group_message_sender',
            component: group_message_sender,
        }, {
            path: '/group_message_sender_tbn',
            name: 'group_message_sender_tbn',
            component: group_message_sender_tbn,
        }, {
            path: '/fleet_assistant',
            name: 'fleet_assistant',
            component: fleet_assistant,
        }, {
            path: '/support_ticket_list',
            name: 'support_ticket_list',
            component: support_ticket_list,
        }, {
            path: '/support_ticket_create',
            name: 'support_ticket_create',
            component: support_ticket_create,
        }, {
            path: '/support_ticket_details',
            name: 'support_ticket_details',
            component: support_ticket_details,
        }, {
            path: '/user',
            name: 'user_list',
            component: user_list,
        }, {
            path: '/driver_list',
            name: 'driver_list',
            component: driver_list,
        }, {
            path: '/driver_list_tbn',
            name: 'driver_list_tbn',
            component: driver_list_tbn,
        }, {
            path: '/route_addresses',
            name: 'route_addresses',
            component: route_addresses,
        }, {
            path: '/route_assignments',
            name: 'route_assignments',
            component: route_assignments,
        }, {
            path: '/report_converter',
            name: 'report_converter',
            component: report_converter,
        }, {
            path: '/user_detail',
            name: 'user_detail',
            component: user_detail,
        }, {
            path: '/driver_detail',
            name: 'driver_detail',
            component: driver_detail,
        }, {
            path: '/driver_detail_tbn',
            name: 'driver_detail_tbn',
            component: driver_detail_tbn,
        }, {
            path: '/user_create',
            name: 'user_create',
            component: user_create,
        }, {
            path: '/alert_list',
            name: 'alert_list',
            component: alert_list,
        }, {
            path: '/hos_history_report',
            name: 'hos_history_report',
            component: hos_history_report,
        }, {
            path: '/tyler_route_processor',
            name: 'tyler_route_processor',
            component: tyler_route_processor,
        }, {
            path: '/compare_drivers',
            name: 'compare_drivers',
            component: compare_drivers,
        }, {
            path: '/compare_driver_profiles',
            name: 'compare_driver_profiles',
            component: compare_driver_profiles,
        }, {
            path: '/compare_drivers_history',
            name: 'compare_drivers_history',
            component: compare_drivers_history,
        }, {
            path: '/driver_scorecard',
            name: 'driver_scorecard',
            component: driver_scorecard,
        }, {
            path: '/driver_comparison',
            name: 'driver_comparison',
            component: driver_comparison,
        }, {
            path: '/booking_file_list',
            name: 'booking_file_list',
            component: booking_file_list,
        }, {
            path: '/actuals_simulator',
            name: 'actuals_simulator',
            component: actuals_simulator,
        }, {
            path: '/event_notes_list',
            name: 'event_notes_list',
            component: event_notes_list,
        }, {
            path: '/vehicle_status_history',
            name: 'vehicle_status_history',
            component: vehicle_status_history,
        }, {
            path: '/vehicle_status',
            name: 'vehicle_status',
            component: vehicle_status,
        }, {
            path: '/vehicle_status_es',
            name: 'vehicle_status_es',
            component: vehicle_status_es,
        }, {
            path: '/vehicle_status_dvir',
            name: 'vehicle_status_dvir',
            component: vehicle_status_dvir,
        }, {
            path: '/vehicle_status_dvir_fasttrak',
            name: 'vehicle_status_dvir_fasttrak',
            component: vehicle_status_dvir_fasttrak,
        }, {
            path: '/vehicle_status_dvir_tbn',
            name: 'vehicle_status_dvir_tbn',
            component: vehicle_status_dvir_tbn,
        }, {
            path: '/vehicle_status_maint_tbn',
            name: 'vehicle_status_maint_tbn',
            component: vehicle_status_maint_tbn,
        }, {
            path: '/vehicle_status_maint',
            name: 'vehicle_status_maint',
            component: vehicle_status_maint,
        }, {
            path: '/vehicle_status_tbn',
            name: 'vehicle_status_tbn',
            component: vehicle_status_tbn,
        }, {
            path: '/driver_board',
            name: 'driver_board',
            component: driver_board,
        }, {
            path: '/trip_sheet_tbn',
            name: 'trip_sheet_tbn',
            component: trip_sheet_tbn,
        }, {
            path: '/vehicle_maint_summary',
            name: 'vehicle_maint_summary',
            component: vehicle_maint_summary,
        }, {
            path: '/trip_sheet',
            name: 'trip_sheet',
            component: trip_sheet,
        }, {
            path: '/dispatch_board_tbn',
            name: 'dispatch_board_tbn',
            component: dispatch_board_tbn,
        }, {
            path: '/driver_bid_board_tbn',
            name: 'driver_bid_board_tbn',
            component: dispatch_bookings_driver_bid_board_tbn,
        }, {
            path: '/driver_bid_manage_board_tbn',
            name: 'driver_bid_manage_board_tbn',
            component: dispatch_bookings_driver_bid_manager_board_tbn,
        }, {
            path: '/sos_list',
            name: 'sos_list',
            component: sos_list,
        }, {
            path: '/sos_detail',
            name: 'sos_detail',
            component: sos_detail,
        }, {
            path: '/register',
            name: 'direct_register',
            component: direct_register,
        }, {
            path: '/map',
            name: 'vehicle_map_direct',
            component: vehicle_map_direct,
        }, {
            path: '/vehicle-util-monthly-tbn',
            name: 'planned_vehicle_types_monthly_tbn',
            component: planned_vehicle_types_monthly_tbn,
        }, {
            path: '/driver-util-monthly-tbn',
            name: 'planned_driver_types_monthly_tbn',
            component: planned_driver_types_monthly_tbn,
        }, {
            path: '/driver-util-monthly-tbn/:tenant_id',
            name: 'planned_driver_types_monthly_tbn_standalone',
            component: planned_driver_types_monthly_tbn,
        }, {
            path: '/driver-util-monthly-cm',
            name: 'planned_driver_types_monthly_cm',
            component: planned_driver_types_monthly_cm,
        }, {
            path: '/driver-util-monthly-cm/:tenant_id',
            name: 'planned_driver_types_monthly_cm_standalone',
            component: planned_driver_types_monthly_cm,
        }, {
            path: '/drivermap',
            name: 'vehicle_map_driver',
            component: vehicle_map_driver,
        }, {
            path: '/vehicle_trip_history',
            name: 'vehicle_trip_history',
            component: vehicle_trip_history,
        }, {
            path: '/vehicle_trip_history/:vehicleId',
            name: 'vehicle_trip_history_by_id',
            component: vehicle_trip_history,
        }, {
            path: '/vehicle_route_history',
            name: 'vehicle_route_history',
            component: vehicle_route_history,
        }, {
            path: '/vehicle_route_history/:vehicleId',
            name: 'vehicle_route_history_by_id',
            component: vehicle_route_history,
        }, {
            path: '/vehicle-track',
            name: 'vehicle_map_track',
            component: vehicle_map_track,
        }, {
            path: '/fleet-track',
            name: 'vehicle_map_track_fleet',
            component: vehicle_map_track_fleet,
        }, {
            path: '/fleet-track-fabbus',
            name: 'vehicle_map_track_fleet_fabbus',
            component: vehicle_map_track_fleet_fabbus,
        }, {
            path: '/booking-track',
            name: 'vehicle_map_by_booking',
            component: vehicle_map_by_booking,
        }, {
            path: '/sos_map',
            name: 'sos_map',
            component: sos_detail,
        }, {
            path: '/vsm',
            name: 'vsm',
            component: vehicle_status_dvir,
        }, {
            path: '/vsm-v1',
            name: 'vsm_v1',
            component: vehicle_status,
        }, {
            path: '/status',
            name: 'status',
            component: vehicle_status_dvir_tbn,
        }, {
            path: '/vsm-tbn',
            name: 'vsm_tbn',
            component: vehicle_status_tbn,
        }
    ]
})


// router.beforeEach((to, _, next) => {
//     console.log("path - " + JSON.stringify(to))
//     if (to.matched[0].path.startsWith('/sos_map')) {
//         localStorage.clear()
//         localStorage.setItem('sos_detail', true)
//         router.push(to.fullPath.replace("sos_map", "sos_detail"))
//     }
//     else if (to.matched[0].path.startsWith('/map')) {
//         localStorage.clear()
//         localStorage.setItem('vehicle_map_direct', true)
//         router.push(to.fullPath.replace("map", "vehicle_map_direct"))
//     }
//     else if (to.matched[0].path.startsWith('/register')) {
//         console.log("route register map")
//         localStorage.clear()
//         localStorage.setItem('direct_register', true)
//         router.push(to.fullPath.replace("register","direct_register"))
//         //router.replace({ path: "/direct_register"})
//     }
//     else {
//         next()
//     }
// });

export default router
